import React from 'react';
import logo from '../assets/logo1.png'; // Replace with your logo path
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-wrapper">
      {/* Full Screen Overlay */}
      <div className="loader-overlay"></div>

      {/* Logo Animation */}
      <div className="loader-container">
        <img src={logo} alt="Loading..." className="fade-logo" />
      </div>
    </div>
  );
};

export default Loader;
